var map = {
	"./body-blood-detox.svg": [
		1015,
		557
	],
	"./body-blood-insulin.svg": [
		1016,
		558
	],
	"./body-blood-stream.svg": [
		1017,
		559
	],
	"./body-blood-sugar.svg": [
		1018,
		560
	],
	"./body-bones-strong.svg": [
		1019,
		561
	],
	"./body-bones-weak.svg": [
		1020,
		562
	],
	"./body-coordination.svg": [
		1021,
		563
	],
	"./body-gut.svg": [
		1022,
		564
	],
	"./body-heart.svg": [
		1023,
		565
	],
	"./body-joints.svg": [
		1024,
		566
	],
	"./body-lung.svg": [
		1025,
		567
	],
	"./body-lymph-flow.svg": [
		1026,
		568
	],
	"./body-muscles-spasm.svg": [
		1027,
		569
	],
	"./body-muscles-zoom.svg": [
		1028,
		570
	],
	"./body-protection.svg": [
		1029,
		571
	],
	"./body-spine.svg": [
		1030,
		572
	],
	"./body-weight.svg": [
		1031,
		573
	],
	"./bowl-1.svg": [
		1032,
		574
	],
	"./bowl-2.svg": [
		1033,
		575
	],
	"./bowl-3.svg": [
		1034,
		576
	],
	"./bowl-4.svg": [
		1035,
		577
	],
	"./bowl-5.svg": [
		1036,
		578
	],
	"./bowl-6.svg": [
		1037,
		579
	],
	"./misc-holistic.svg": [
		1038,
		580
	],
	"./misc-low-level.svg": [
		1039,
		581
	],
	"./misc-mailbox.svg": [
		1040,
		582
	],
	"./misc-shipping.svg": [
		1041,
		583
	],
	"./nutrition-less-alcohol.svg": [
		1042,
		584
	],
	"./nutrition-less-sugar.svg": [
		1043,
		585
	],
	"./nutrition-omega3.svg": [
		1044,
		586
	],
	"./nutrition-protein.svg": [
		1045,
		587
	],
	"./nutrition-vegetable-fat.svg": [
		1046,
		588
	],
	"./nutrition-vegetarian-1.svg": [
		1047,
		589
	],
	"./nutrition-vegetarian-2.svg": [
		1048,
		590
	],
	"./nutrition-water.svg": [
		1049,
		591
	],
	"./object-404.svg": [
		1050,
		592
	],
	"./object-battery.svg": [
		1051,
		593
	],
	"./object-brain-happy.svg": [
		1052,
		594
	],
	"./object-clock.svg": [
		1053,
		595
	],
	"./object-confetti.svg": [
		1054,
		596
	],
	"./object-fascia-roll.svg": [
		1055,
		597
	],
	"./object-feather.svg": [
		1056,
		598
	],
	"./object-grain.svg": [
		1057,
		599
	],
	"./object-spinning-top.svg": [
		1058,
		600
	],
	"./object-weight-heavy.svg": [
		1059,
		601
	],
	"./time-coffee.svg": [
		1060,
		602
	],
	"./time-nutrition-1.svg": [
		1061,
		603
	],
	"./time-nutrition-2.svg": [
		1062,
		604
	],
	"./time-stopwatch.svg": [
		1063,
		605
	],
	"./time-workout.svg": [
		1064,
		606
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 806;
module.exports = webpackAsyncContext;